(ns frontend.ui.page.lp-portal.landing-page.reports-section.funds.funds-list-header.view
  (:require
   [frontend.ui.component.lp-portal.report-list-header.view :as report-list-header]
   [frontend.ui.page.lp-portal.landing-page.event :as event]
   [frontend.ui.page.lp-portal.landing-page.sub :as sub]
   [re-frame.core :as rf]
   [common.localization :as loc]))

(defn funds-list-header
  [report]
  [report-list-header/report-list-header
   {:on-sort-order-change (fn [sort-order]
                            (rf/dispatch [::event/set-funds-sort-order sort-order]))
    :sort-order @(rf/subscribe [::sub/funds-sort-order])
    :items      [{:weight    10
                  :key       :fund-name
                  :sort-keys [:lp-report/data :fund-landing-page-data :fund-name]
                  :children  (loc/tr :fund-name)}
                 {:weight    6
                  :key       :reference-date
                  :sort-keys [:lp-report/data :reference-date]
                  :children  (loc/tr :reference-date)}
                 {:weight    6
                  :key       :fund-size
                  :sort-keys [:lp-report/data :fund-landing-page-data :fund-size]
                  :children  (loc/tr :fund-size)}
                 {:weight    5
                  :key       :paid-in-pct
                  :sort-keys [:lp-report/data :fund-landing-page-data :paid-in-pct]
                  :children  (loc/tr :paid-in-pct)}
                 {:weight    6
                  :min-screen-width-visible 700
                  :key       :fair-value
                  :sort-keys [:lp-report/data :fund-landing-page-data :fair-value]
                  :children  (loc/tr :nav-in-currency
                                              [(get report :lp-report/currency "EUR")])}
                 {:weight    4
                  :key       :cash-called
                  :min-screen-width-visible 800
                  :sort-keys [:lp-report/data :fund-landing-page-data :cash-called]
                  :children  (loc/tr :cash-called)}
                 {:weight    3
                  :key       :tvpi
                  :min-screen-width-visible 900
                  :sort-keys [:lp-report/data :fund-landing-page-data :tvpi]
                  :children  (loc/tr :fund-tvpi)}
                 {:weight    7
                  :min-screen-width-visible 1000
                  :key       :net-irr
                  :sort-keys [:lp-report/data :fund-landing-page-data :net-irr]
                  :children  (loc/tr :fund-net-irr)}
                 {:weight 2
                  :key    :empty}
                ]}])
